import { countriesList } from '@/app/common/app-config/filter-models/countries';
import { genderOptions } from '@/app/common/app-config/filter-models/gender';
import { interestsList } from '@/app/common/app-config/filter-models/interests';
import { platformsList } from '@/app/common/app-config/filter-models/platforms';
import { creatorSortOptions } from '@/app/common/app-config/filter-models/sort';
import { influencerSizes } from '@/app/common/app-config/filter-models/tiktok-influencers';
import { verifiedOptions } from '@/app/common/app-config/filter-models/verified';
import { ActiveFiltersModel, FilterCreatorsDto } from '@/app/common/general-types/filters.dto';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { CurrentUserService } from '@/app/common/current-user/current-user.service';

@Injectable({
  providedIn: 'root',
})
export class AdminFilter {
  
  /** Services */
  private currentUserService = inject(CurrentUserService);
  /** Services - END */


  activeFiltersSignal: WritableSignal<ActiveFiltersModel> = signal( {
    ageOptions: { min: 0, max: 60 },
    interestsOptions: interestsList,
    countryOptions: countriesList,
    genderOptions: genderOptions,
    tiktokSizeOptions: influencerSizes,
    instagramSizeOptions: influencerSizes,
    youtubeSizeOptions: influencerSizes,
    snapchatSizeOptions: influencerSizes,
    sortOptions: creatorSortOptions,
    platformOptions: platformsList,
    isVerifiedOptions: verifiedOptions,
    homeTownSearchTerm: '',
  });

  initFiltersObject: FilterCreatorsDto = {
    skip: 0,
    take: 20,
    exclusive_to_business_id: null,
    exclusive_to_agency_id: null
  }

  filtersObjectSignal: WritableSignal<FilterCreatorsDto> = signal(this.initFiltersObject);

}
